// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popover.popperClass{z-index:999;padding:0!important;overflow-x:auto}p{padding:0;margin:0}.el-popper.popperClass[x-placement^=right] .popper__arrow:after{border-right-color:#f3f2f2}", ""]);
// Exports
module.exports = exports;
